import { WebsocketError } from './types';

type Meta = {
  resolve: (data: unknown) => void;
  reject: (error: WebsocketError) => void;
};

export class ResponseDeffers {
  private _responseDeffers: Record<string, Meta> = {};

  handleRequest(id: string, meta: Meta): void {
    this._responseDeffers[id] = {
      resolve: meta.resolve,
      reject: meta.reject,
    };
  }

  handleResponse(
    id: string,
    data: unknown,
    error: WebsocketError | undefined,
  ): void {
    if (error !== undefined) {
      this._responseDeffers[id]?.reject(error);
    } else {
      this._responseDeffers[id]?.resolve(data);
    }
    delete this._responseDeffers[id];
  }
}

export const responseDeffers = new ResponseDeffers();
